var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.51172 0.25H13.75V5.48828H12.2383V2.81641L4.89062 10.1641L3.83594 9.10938L11.1836 1.76172H8.51172V0.25ZM12.2383 12.2383V7H13.75V12.2383C13.75 12.6367 13.5977 12.9883 13.293 13.293C12.9883 13.5977 12.6367 13.75 12.2383 13.75H1.76172C1.33984 13.75 0.976562 13.6094 0.671875 13.3281C0.390625 13.0234 0.25 12.6602 0.25 12.2383V1.76172C0.25 1.33984 0.390625 0.988281 0.671875 0.707031C0.976562 0.402344 1.33984 0.25 1.76172 0.25H7V1.76172H1.76172V12.2383H12.2383Z",
    fill: "#212121",
    fillOpacity: 0.6
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPo);
export default __webpack_public_path__ + "static/media/po.ca7d44c40b67cc96c7c3aefd18f077d5.svg";
export { ForwardRef as ReactComponent };